import React from 'react';
import { usePrefixCls } from '@byte-design/config';
import { useFileUpdate, useUpload } from '../rc-upload/';
import { Picture } from './Picture';
export function PictureFileListItem(props) {
  var file = props.file,
      size = props.size,
      _props$actions = props.actions,
      actions = _props$actions === void 0 ? [] : _props$actions,
      _props$hasClose = props.hasClose,
      hasClose = _props$hasClose === void 0 ? true : _props$hasClose,
      domRef = props.domRef,
      iconRender = props.iconRender;
  var fileUpload = useUpload();
  var pictureFileListItemCls = usePrefixCls('upload-file-list-picture-item');
  var pictureFileListItemContentCls = usePrefixCls('upload-file-list-picture-item-content');
  var pictureFileListItemInfoCls = usePrefixCls('upload-file-list-picture-item-info');
  useFileUpdate(file.id);
  var progress = file.getProgress();
  return React.createElement("li", {
    className: pictureFileListItemCls,
    "data-status": file.fileStatus,
    ref: domRef
  }, React.createElement("div", {
    className: pictureFileListItemContentCls
  }, React.createElement(Picture, {
    file: file,
    size: size,
    border: true,
    hasProgress: fileUpload.hasProgress,
    progress: progress,
    actions: actions,
    hasClose: hasClose,
    iconRender: iconRender
  })), file.fileStatus === "FAIL" && React.createElement("div", {
    className: pictureFileListItemInfoCls
  }, file.errmsg));
}